import {View, Text, FlatList,ScrollView} from 'react-native-web'
import {useState, useEffect} from 'react'
import {Description} from './SheetsComponent/Description'
import { ABLIST1 } from '../../../../List/AbilityList'
import { AbilityList, AbilityBody, Title,} from '../../../../element/Text'
import { ButtonUser } from '../../../../element/Button'
import {CharacterSave} from './SheetsComponent/CharacterSave.js'
import {doc, updateDoc} from 'firebase/firestore';
import { db } from '../../../../firebase/FirebaseConfig'
import { useNavigation } from '@react-navigation/native'





const SetAbility = props =>{
    const navigation=useNavigation()
    const Name= props.Name;
    const Sign= props.Sign;
    const Background= props.Background;
    const tribename= props.tribename;
    const [List, setList]=useState([]);
    const [List1, setList1]=useState([]);
    const [Check, setCheck] = useState(new Array(ABLIST1.length).fill(false));
    const [body, setBody]=useState(0);
    const [mental, setMental]=useState(0);
    const [social, setSocial]=useState(0);
    const [abilityScore, setAbilityScore]=useState(0);
    const [error, setError]= useState('');
    const [flip, setFlip]=useState(false);
    const [flip1, setFlip1]=useState(false);
    const [flip2, setFlip2]=useState(false);
    const [color, setColor]= useState('#F9BA49');
    const [avalue, setAvalue]=useState(0);
    const [bvalue, setBvalue]=useState(0);
    const [cvalue, setCvalue]=useState(0);
    const [namea, setNameA]=useState('');
    const [nameb, setNameb]=useState('');
    const [namec, setNamec]=useState('');
    const data =[...ABLIST1]
    const [groupedData, setGroupedData] = useState(GroupData(data));

  function GroupData (data) {
      const groups = {};
      data.forEach(item => {
        if (!groups[item.tipo]) {
          groups[item.tipo] = [];
        }
        groups[item.tipo].push(item);
      });
      return Object.keys(groups).map(key => ({ tipo: key, data: groups[key] }));
    };

   function Bac(){
    
    setList('');
     setList1('');
     setCheck(new Array(ABLIST1.length).fill(false));
     setBody(0);
     setMental(0);
     setSocial(0);
     setAbilityScore(0);
     setAvalue(0)
     setBvalue(0)
     setCvalue(0)
     setNameA('');
    setNameb('');
    setNamec('');
    setFlip(!flip); 
    navigation.navigate("Home");} 

   function score ({a,b,c}){
                            let a1=body+a;
                            let b1=mental+b;
                            let c1=social+c;
                            let score= a1+b1+c1;
                            setBody(a1);
                            setMental(b1);
                            setSocial(c1);
                            setAbilityScore(score);
                            setError("");
                            setFlip1(false);
                            setColor('#F9BA49')}

   async function SavePG(){   
     console.log(props.id)  
    await updateDoc(doc(db, "personaggi", props.id), {
      Name: Name,
      Tribe: tribename,
      User: props.user,
      UserName:props.userName,
      Death: false,
      Key: props.id,
      Background: Background,
      Abilita: [...List, "CONOSCENZE TRIBU'"],
      Sign:Sign,
      Complete:false,
      Mod:true,
      Mage:false,
      Erinni:'',
      Arcane:[],},
    );
    Bac()}

   function Counter(){
                      useEffect(()=>{
                                      if(tribename=='Volkron'){
                                                          if(mental<3){setAvalue(2-mental)}
                                                          else{setAvalue(0)}
                                                          if(body<2){setBvalue(1-body)}
                                                          else{setBvalue(0)}
                                                          setNameA( 'Mentali: ')
                                                          setNameb('Fisiche: ')
                                                          setCvalue('')
                                                          setNamec('')}
                                      if(tribename=='Brennen'){
                                                                if(body<3){setAvalue(2-body)}
                                                                else{setAvalue(0)}
                                                                setBvalue('')
                                                                setNameA( 'Fisiche: ')
                                                                setNameb('')
                                                                setCvalue('')
                                                                setNamec('')}
                                      if(tribename=='Kumpania'){
                                                            if(body<2){setAvalue(1-body)}
                                                            else{setAvalue(0)}
                                                            if(mental<2){setBvalue(1-mental)}
                                                            else{setBvalue(0)}
                                                            if(social<2){setCvalue(1-social)}
                                                            else{setCvalue(0)}
                                                            setNameA('Fisiche: ')
                                                            setNameb('Mentali: ')
                                                            setNamec('Sociali: ')}
                                      if(tribename=='Popolo di Zao'){
                                                                    if(mental<3){setAvalue(2-mental)}
                                                                    else{setAvalue(0)}
                                                                    if(social<2){setBvalue(1-social)}
                                                                    else{setBvalue(0)}
                                                                    setCvalue('')
                                                                    setNameA('Mentali: ')
                                                                    setNameb('Sociali: ')
                                                                    setNamec('')}
                                      if(tribename=='Priorato di Aletheia'){
                                                                            if(mental<3){setAvalue(2-mental)}
                                                                            else{setAvalue(0)}
                                                                            setBvalue('')
                                                                            setCvalue('')
                                                                            setNameA('Mentali: ')
                                                                            setNameb('')
                                                                            setNamec('')}},[mental,body,social])
    
    return(
      <View>
      {flip2? <View style={{width:'100%', height:'100%', alignItems:'center'}}><Text style={{color: '#F9BA49',fontSize:18, fontWeight:'bold'}}>{'Abilità da selezionare'}</Text><AbilityBody color1={'#F9BA49'} value={'\n'+namea+avalue+'\n'+nameb+bvalue+'\n'+namec+cvalue} /></View>:<AbilityBody color1={'#F9BA49'} value={props.triberule} />}
      </View>);}


   function Checking({dataItem, index}){
     
                                      var a=0;
                                      var b=0;
                                      var c=0;
                                      setFlip2(true)
        if (List.includes(dataItem.nome)){
                                      var updatedCheckedState = [...Check];
                                      let index1= List.findIndex((obj)=> obj=== dataItem.nome);
                                      List.splice(index1, 1);
                                      List1.splice(index1, 1);
                                      setList ([...List]);
                                      setList1 ([...List1]);
                                      updatedCheckedState[index]=!updatedCheckedState[index];
                                      setCheck(updatedCheckedState);
                                      if(dataItem.tipo=='Fisiche'){a=a-1};
                                      if(dataItem.tipo=='Mentali'){b=b-1};
                                      if(dataItem.tipo=='Sociali'){c=c-1};
                                      if(dataItem.requisiti != 'null'){ var position1 = ABLIST1.findIndex((obj) => obj.nome === dataItem.requisiti);
                                                                    if (Check[index]==true && Check[position1]==true ){let index2= List.findIndex((obj)=> obj=== dataItem.requisiti);
                                                                                                                        List.splice(index2, 1);
                                                                                                                        setList ([...List]);
                                                                                                                        List1.splice(index2, 1);
                                                                                                                        setList1 ([...List1]);
                                                                                                                        updatedCheckedState[position1]=false;
                                                                                                                        setCheck(updatedCheckedState);
                                                                                                                        var item1 = ABLIST1[position1];
                                                                                                                        if(item1.tipo=='Fisiche'){a=a-1;}
                                                                                                                        if(item1.tipo=='Mentali'){b=b-1;}
                                                                                                                        if(item1.tipo=='Sociali'){c=c-1;}
                                                                                                                        if(item1.requisiti != 'null'){var position2 = ABLIST1.findIndex((obj) => obj.nome === item1.requisiti);

                                                                                                                                                      if (Check[position1]==true && Check[position2]==true ){let index3= List.findIndex((obj)=> obj=== item1.requisiti);
                                                                                                                                                                                                              List.splice(index3, 1);
                                                                                                                                                                                                              setList ([...List]);
                                                                                                                                                                                                              List1.splice(index3, 1);
                                                                                                                                                                                                              setList1 ([...List1]);
                                                                                                                                                                                                              updatedCheckedState[position2]=false;
                                                                                                                                                                                                              setCheck(updatedCheckedState);
                                                                                                                                                                                                              var item2 = ABLIST1[position2];
                                                                                                                                                                                                              if(item2.tipo=='Fisiche'){a=a-1};
                                                                                                                                                                                                              if(item2.tipo=='Mentali'){b=b-1};
                                                                                                                                                                                                              if(item2.tipo=='Sociali'){c=c-1};
                                                                                                                                                                                                              score({a,b,c});}
                                                                                                                                                      else{score({a,b,c})}};}
                                                                      else{score({a,b,c});}}}
        else{
            if(abilityScore+1==7){setError("Superi il numero massimo di abilità permesse, se desideri quest'Abilita' deselezionane un'altra");
                                  setFlip1(true);
                                  setColor('#ee4550');}
            else{
                  if( !List.includes(dataItem.prerequisiti) && dataItem.prerequisiti != 'nessuno'){
                                                                                            setError("Non superi i requisiti per selezionare quest'Abilità, controllane la descrizione per maggiori informazione cliccando sul suo nome"); 
                                                                                            setFlip1(true);
                                                                                            setColor('#ee4550');}                           
                  else{
                        var updatedCheckedState = [...Check];
                        updatedCheckedState[index]=!updatedCheckedState[index];
                        setCheck(updatedCheckedState);
                        setList([...List, dataItem.nome]);
                        setList1([...List1, dataItem]);
                        if(dataItem.tipo=='Fisiche'){a=a+1;}
                        if(dataItem.tipo=='Mentali'){b=b+1;}
                        if(dataItem.tipo=='Sociali'){c=c+1;}
                        score({a,b,c});}}}}

   

  return (
     <View  style={{width:'100%', height:'90%'}}>
        <View style={{width:'90%',height:'26%', backgroundColor:'#252525', alignSelf:'center', marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:color, borderWidth:1.8}}>
          <Title color1={'#F9BA49'} value={'Abilità Selezionate'}/>
          <AbilityList list={List}/>
          <Text style={{color:'#F9BA49', fontSize:12,position:'absolute', right:15, bottom:7.5, fontWeight:'600' }}>{abilityScore + "/6"}</Text>
        </View>
        <ScrollView style={{width:'90%', height:'45%', backgroundColor:'#252525', borderRadius:16, alignSelf:'center', marginTop:15, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,borderColor:color, borderWidth:1.8}}>
          <Title color1={'#F9BA49'} value={'Lista Abilità'}/>
          {ABLIST1.map((dataItem, index) => (
           <Description ability={dataItem.nome} size={'80%'} key={dataItem.id} title={dataItem.nome} type={dataItem.tipo} description={dataItem.descrizione} prerequisite={dataItem.prerequisiti} onPress2={()=>{Checking({dataItem, index})}} Check={Check[index]} checkbox={true}/>
          ))}
        </ScrollView>
        <View style={{alignItems:'center', alignSelf:'center', width:'90%', height:'20%', backgroundColor:'#252525', borderRadius:16, marginTop:15,borderColor:'#F9BA49', borderWidth:1.8, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, padding:15}} >
          {flip1? <AbilityBody color1={'#ee4550'} value={error} />:<Counter/>}
        </View> 
        <View style={{alignItems:'center'}}>
         {flip? <CharacterSave modalv={flip} onPress={()=>{setFlip(!flip)}} onPress1={()=>{SavePG()}}/> : <ButtonUser text={'Salva Pg'} wsize={'50%'} onPress={()=>{setFlip(!flip)}}/> }
        </View>
      </View>);}

export default SetAbility

/* <FlatList
      data={groupedData}
      renderItem={({ item }) => (
        <View>
          <Title color1={'#F9BA49'} value={item.tipo}/>
          {item.data.map((dataItem, index) => (
           <Description ability={dataItem.nome} size={'80%'} key={dataItem.id} title={dataItem.nome} type={dataItem.tipo} description={dataItem.descrizione} prerequisite={dataItem.prerequisiti} onPress2={()=>{Checking({dataItem, index})}} Check={Check[index]} checkbox={true}/>
          ))}
        </View>
      )}
      keyExtractor={(item, index) => `${item.tipo}-${index}`}
    />*/ 